import {environment} from "../environments/environment"
import {LogLevel, OpenIdConfiguration} from "angular-auth-oidc-client";

export const authConfig: OpenIdConfiguration = {
  authority: environment.identityServerBaseUrl,
  redirectUrl: `${window.location.origin}/auth/signin-oidc`,
  postLogoutRedirectUri: window.location.origin,
  clientId: 'syl.interpreter.portal',
  scope: 'profile openid roles offline_access syl.interpreter.api.fullaccess',
  responseType: 'code',
  silentRenew: true,
  useRefreshToken: true,
  logLevel: environment.production ? LogLevel.Error : LogLevel.Debug,
  autoUserInfo: true
}